import React from 'react';
import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import { MappedLeaveItem } from '../../shared/types';
import { formatLeaveTypeWithSubType } from 'domain/people/leave/shared/leaveTypeDisplay';
import ExcludedFromBalanceBadge from 'domain/people/leave/shared/badge/ExcludedFromBalanceBadge';

const BalancesLeavesTypeField = () => {
  const { data } = useShowContext<MappedLeaveItem>();
  const leave = data?.getData();
  const { type, subType, sickDayReason, leaveType, isExtended, isExcludedFromBalance } = leave ?? {};

  const display = formatLeaveTypeWithSubType({
    type: type ?? null,
    subType: subType ?? null,
    sickDayReason: sickDayReason ?? null,
    leaveTypeFallback: !type ? (leaveType ?? null) : null,
  });

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body1" color="secondary">
        {display}
      </Typography>
      {isExtended && <Badge color="info">Extended</Badge>}
      {isExcludedFromBalance && <ExcludedFromBalanceBadge />}
    </Box>
  );
};

export default BalancesLeavesTypeField;
